<div class="card-white">
  <!-- Header con título y botones -->
  <div class="card-header mb-4">
    <div class="title-section">
      <h2 class="header-title">Simulador - {{ promocion }}</h2>
    </div>
    <div class="button-section">
      <button mat-flat-button class="btn-success" (click)="simular()" [disabled]="form.invalid || loading"
        appPermissionControl="P151B0001">
        <mat-icon *ngIf="!loading">calculate</mat-icon>
        <mat-spinner *ngIf="loading" diameter="18" style="display: inline-block; margin-right: 8px; vertical-align: middle;"></mat-spinner>
        {{ loading ? 'Simulando...' : 'Simular' }}
      </button>
      <button mat-flat-button class="btn-back" (click)="atras()" appPermissionControl="P151B0003">
        <mat-icon>arrow_back</mat-icon>
        Atrás
      </button>
    </div>
  </div>

  <!-- Formulario -->
  <form [formGroup]="form" class="form-container" appPermissionControl="P151F0001">
    <div class="form-row">
      <div class="form-field flex-grow-1">
        <input pInputText type="number" formControlName="monto" class="form-control" placeholder="Ingrese monto"
          appPermissionControl="P151K0001">
        <label>Monto</label>
      </div>
      <div class="form-field flex-grow-1 mt-1">
        <p-dropdown formControlName="plazo" [options]="terms" optionLabel="plazo" optionValue="plazo"
          placeholder="Seleccione plazo" appPermissionControl="P151K0002"></p-dropdown>
        <label>Plazo</label>
      </div>
      <div class="form-field flex-grow-1" *ngIf="mostrarCuotaInicial">
        <input pInputText type="number" formControlName="cuotaInicial" class="form-control"
          placeholder="Ingrese cuota inicial" appPermissionControl="P151K0003">
        <label>Cuota Inicial</label>
      </div>
      <div class="form-field flex-grow-1 mt-1">
        <p-dropdown formControlName="ciclo" [options]="cicles" optionLabel="ciclo" optionValue="ciclo"
          placeholder="Seleccione ciclo" appPermissionControl="P151K0004"></p-dropdown>
        <label>Ciclo</label>
      </div>
    </div>

    <!-- Campos dinámicos -->
    <div class="form-row" *ngFor="let campo of dynamicFields">
      <div class="form-field flex-grow-1" *ngIf="campo.valor === '1'">
        <input pInputText type="number" [formControlName]="getControlName(campo)" class="form-control"
          [placeholder]="'Ingrese ' + campo.descripcion.toLowerCase()" appPermissionControl="P151K0005">
        <label>{{ campo.descripcion | titlecase }}</label>
      </div>
      <div class="form-field flex-grow-1 mt-1" *ngIf="campo.iTipoCalculo === '3'">
        <p-dropdown [formControlName]="getControlName(campo) + '_Pago'" [options]="payments" optionLabel="sEtiqueta"
          optionValue="iValor" [placeholder]="'Seleccione ' + campo.descripcion.toLowerCase() + ' pago'"
          appPermissionControl="P151K0006"></p-dropdown>
        <label>{{ campo.descripcion | titlecase }} Pago</label>
      </div>
      <div class="form-field flex-grow-1 mt-1" *ngIf="campo.iTipoCalculo === '3'">
        <p-dropdown [formControlName]="getControlName(campo) + '_Plazo'" [options]="termsNumVar" optionLabel="iPlazo"
          optionValue="iPlazo" [placeholder]="'Seleccione ' + campo.descripcion.toLowerCase() + ' plazo'"
          appPermissionControl="P151K0007"></p-dropdown>
        <label>{{ campo.descripcion | titlecase }} Plazo</label>
      </div>
    </div>
  </form>
</div>

  <!-- TABLA SIMULAR -->
  <div class="mt-2">
    <p-table #dt [value]="dataSource" [rows]="10" [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[5, 10, 20]" [scrollable]="true" scrollHeight="600px" styleClass="p-datatable-gridlines"
      [resizableColumns]="true" [autoLayout]="true" responsiveLayout="scroll" [loading]="loading"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      appPermissionControl="P151T0001">
      <ng-template pTemplate="header">
        <tr>
          <th [pSortableColumn]="'Pago'" class="th-prime" appPermissionControl="P151C0001">
            Cuotas
            <p-sortIcon [field]="'Pago'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'FechaPago'" class="th-prime" appPermissionControl="P151C0002">
            Fecha
            <p-sortIcon [field]="'FechaPago'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'dias'" class="th-prime" appPermissionControl="P151C0003">
            Días
            <p-sortIcon [field]="'dias'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'PagoCap'" class="th-prime" appPermissionControl="P151C0005">
            Ahorro Mensual
            <p-sortIcon [field]="'PagoCap'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'PagoInt'" class="th-prime" appPermissionControl="P151C0006">
            Intereses Generados
            <p-sortIcon [field]="'PagoInt'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'Saldo'" class="th-prime" appPermissionControl="P151C0004">
            Total Ahorros
            <p-sortIcon [field]="'Saldo'"></p-sortIcon>
          </th>
          <!-- Columnas dinámicas -->
          <th *ngFor="let column of variables" [pSortableColumn]="column.Campo" class="th-prime"
            appPermissionControl="P151C0007">
            {{ column.Descripcion | titlecase }}
            <p-sortIcon [field]="column.Campo"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-element>
        <tr>
          <td class="td-prime">{{ element.Pago }}</td>
          <td class="td-prime">{{ element.FechaPago == 'null' ? '' : element.FechaPago }}</td>
          <td class="td-prime">{{ element.dias == 'null' ? '' : element.dias }}</td>
          <td class="td-prime">{{ element.PagoCap == 'null' ? '' : element.PagoCap }}</td>
          <td class="td-prime">{{ element.PagoInt == 'null' ? '' : element.PagoInt }}</td>
          <td class="td-prime">{{ element.Saldo == 'null' ? '' : element.Saldo }}</td>
          <!-- Columnas dinámicas -->
          <td *ngFor="let column of variables" class="td-prime">{{ element[column.Campo] }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length + variables.length" class="text-center td-prime">
            <span *ngIf="dataSource.length === 0 && !loading">No hay datos para mostrar</span>
            <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)"
              animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- TABLA EFECTIVO -->
  <div *ngIf="mostrarEfectivo" style="display: flex; flex-direction: column; margin-top: 20px;">
    <div class="titleFm" style="width: 200px; margin-bottom: 10px;">Efectivo</div>
    <div class="card-app content-funciones" style="width: 500px">
      <p-table [value]="efectivosource" [scrollable]="true" styleClass="p-datatable-gridlines" [resizableColumns]="true"
        [autoLayout]="true" responsiveLayout="scroll" appPermissionControl="P151T0002">
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'descripcion'" class="th-prime" appPermissionControl="P151C0009">
              Concepto
              <p-sortIcon [field]="'descripcion'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'valor'" class="th-prime" appPermissionControl="P151C0010">
              Valor
              <p-sortIcon [field]="'valor'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'valoriva'" class="th-prime" appPermissionControl="P151C0011">
              Impuesto
              <p-sortIcon [field]="'valoriva'"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-element>
          <tr>
            <td class="td-prime">{{ element.descripcion | titlecase }}</td>
            <td class="td-prime">{{ element.valor }}</td>
            <td class="td-prime">{{ element.valoriva }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center td-prime">No hay datos para mostrar</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>